/*
    Copyright (C) Paul B. Lucas 2025, 2026  ALL RIGHTS RESERVED
    Licensed to the University of Illinois Urbana Champaign

    This is a Javascript composable that invokes the config API, fetching and storing 
    per-org/college-code configs from the database.   Two methods are incuded:

        fetchConfigOnQuery - selects approver queues based on generalized query array

        saveConfig -         saves a single approver queue to database

    Configs have three special properties:
        apply-college-code
        apply-dept-code
        apply-orgcode
    
        A config applies preferentially to a particular orgcode.  In this case, all college and dept
        codes are *null*.   If an orgcode is set, then college and department codes are ignored.  If an 
        orgcode is *null*, then the config will apply to the department code if set, or to the college code.
        If both orgcode and dept codes are *null*, and college-code is set, then the config appies to all
        departments and orgs in that college.  In the case where none are set, the config is essentially
        useless.

    The fetchs are async functions that awaits a results of an axios call to the RWA API. When promise 
    is resolved, the results are returned in agreements ref.

    API configuration data is stored as JSON file in src/configuration/ and imported as a JSON array.  Import
    can do this from a basic JSON file.  Parameters in the config array include the base-url, the POSTQL ccf
    endpoint, and authentication data for the axios headers (API key).  

    <Revision History>
        02/25/2025       pblucas     created 
        03/16/2026       pblucas     Corrected typos & updated copyright
           
    </Revision History>
*/

import { ref } from 'vue'
import axios from 'axios'
import amApiConfigs from '@/configuration/amAPI.config.json'

const useConfigAPI = () =>    {

    // DO NOT USE DEFAULT FOR AUTH IF AXIOS IS ACCESSING MORE THAN ONE API

    const baseURL  = amApiConfigs['base-url']
    // set specific endpoint for agreements
    const URIConfigsPath    =  amApiConfigs['configs-path'] + '/'
    const URIQS             =  "?v=2"
    //use the POSTQL endpoint 'ccf' for storing
    const ccfURL            =   amApiConfigs['ccfURL']

    // result reference to returns 
    const configResults         =   ref({})           
      
    // reference for returned data on where data was stored (includes pkey, assigned uuid, and number)
    const configKeyData         =   ref({})
    
    const  fetchConfigsOnQuery = async (aQuery)  =>  {

        // convert array of key:value pairs to / delimited components for  URL
        // e.g.,  ["first-name: "john", "last-name":"Doe"]  =>  /first-name/John/last-name/Doe
        let uri = Object.keys(aQuery).map((k) => { 
        return encodeURIComponent(k) + '/' + encodeURIComponent(aQuery[k]);
        }).join('/')
        
        let url =  baseURL + URIConfigsPath + uri + URIQS    
        
        await axios({
            method:         'get',
            url:            url,
            headers:        {Authorization: `${amApiConfigs['apim-key-name']} ${amApiConfigs['apim-key']}`}
        })
        .then ( (response) => {   
            configResults.value  =   response.data.results        
        })
        .catch( error =>  {
            console.log("FetchConfigs:: "+ error.message)
            configResults.value = {}
        })
     
    }   // end function


    const storeConfig =  async (config) => {

        // need to generate attributes data - JSON array
        const payload = JSON.stringify(config)

        let formData = new FormData()
        formData.append("collection","configs")

        // we will update the agreement on a null query string using an POST method
        // and rely on the UPDATE ON DUPLICATE KEY (UUID) in the storeAgreements() database routine
        // 
        formData.append("action","POST")
        formData.append("query","{}")
        formData.append("attributes",payload)
        formData.append("parameters", "{}")
        try {
            await axios({
                method: 'POST',
                url: ccfURL,
                data: formData,
                headers: {'Content-Type': 'multipart/form-data',
                        'Authorization': `${amApiConfigs['apim-key-name']} ${amApiConfigs['apim-key']}`}
            })
            .then( (response) => {
                if (!response.status == 200)   {
                    throw Error ("Axios call failed")
                }
                //console.log("useSaveAgreement:: results: "+JSON.stringify(response.data.results))
                configKeyData.value = response.data.results                     
            })
        }
        catch(error)   {
            console.log("StoreConfig:: error: "+error.message)
        }        
    }
    return {configResults, configKeyData, fetchConfigsOnQuery, storeConfig}
}

export default useConfigAPI

